import { getPlayedGamesPeriods } from "../../../../../../sports/rules.js";
import GameFactEventDto from "../GameFactEventDto.js";

export class StartDto extends GameFactEventDto {

    constructor(event){
        super(event);
        this.tab = event.tab ??"DEBUT"
        this.detail = {
            ...this.detail,
            title : event.detail?.title || "DEBUT",
            comment : event.detail?.comment,
          };

        // Supprime la propriété si elle existe dans l'objet
        if ('isAutomaticCommentary' in this) {
            delete this.isAutomaticCommentary;
        }
    }

    get comment() {
        return this.detail.comment;
      }

    set comment(value) {
        this.detail.comment = value;
    }

    initTimerPeriod(match){
        super.initTimerPeriod(match)

        this.timer =  0
        this.period = match.discipline === 'handball' ? match.period+1 : match.period

        let allPlayablePeriods = getPlayedGamesPeriods(match.discipline);
        this.detail.title = ("DEBUT "+ allPlayablePeriods.get(this.detail.period).name).toUpperCase()

        if(match.period !== 0){
            this.isEnableTrigger = false
        }
        
    }

    updateDetail(key, value, match) {
        super.updateDetail(key, value)
    }
}